import React from "react";
import { Box } from "@chakra-ui/react";
export function SkeletonBox({ className = "", ...props }) {
    return (React.createElement(Box, { className: `hightouch-ui-skeleton-box ${className}`, ...props }));
}
